import { FC } from 'react';
import { useModalContext } from '../../lib/modal';
import { EElementSize } from '../../types';
import { Button, EButtonType } from '../button';
import { Close24Icon } from '../icons';
import { ModalContentStyled } from './modal-content.styled';
import { IModalContentProps } from './modal-content.types';

export const ModalContent: FC<IModalContentProps> = ({
  $title,
  children,
  footer,
}) => {
  const { closeModal } = useModalContext();

  return (
    <ModalContentStyled>
      <div className="modal-header">
        <div className="modal-title">{$title}</div>
        <Button
          onClick={closeModal}
          $size={EElementSize.M}
          $type={EButtonType.GHOST_GRAY}
          prependIcon={<Close24Icon />}
        />
      </div>
      <div className="modal-content">{children}</div>
      {footer && <div className="modal-footer">{footer}</div>}
    </ModalContentStyled>
  );
};
